import { Icon, Tooltip } from 'antd';
import React from 'react';
import { getDataTrend } from '../utils';

type Props = {
    resourceType: 'seo_score' | 'backlinks' | 'loading_time';
    format?: (value: number) => string;
    currentValue?: number;
    comparedTo?: number;
};

export default function SummaryTooltip({ resourceType, currentValue, comparedTo, format = (value) => value.toLocaleString() }: Props) {
    const formattedCurrent = currentValue ? format(currentValue) : undefined;
    const formattedCompared = comparedTo ? format(comparedTo) : undefined;

    const tooltipMessages = {
        seo_score: {
            no_data: 'There is no data for SEO Score in this interval',
            increased: `Your website's SEO Score has increased from  ${formattedCompared} to ${formattedCurrent} out of 100.`,
            decreased: `Your website's SEO Score has decreased from ${formattedCompared} to ${formattedCurrent} out of 100.`,
            equal: `Your website's SEO Score is ${formattedCurrent} out of 100.`,
        },
        backlinks: {
            no_data: 'There is no data for Backlinks Overview metrics in this interval.',
            increased: `The total number of incoming links to your domain has increased from ${formattedCompared} to ${formattedCurrent}.`,
            decreased: `The total number of incoming links to your domain has decreased from ${formattedCompared} to ${formattedCurrent}.`,
            equal: `The total number of incoming links to your domain is ${formattedCurrent}.`,
        },
        loading_time: {
            no_data: 'There is no data for Site Speed metrics in this interval.',
            increased: `Your website's loading time has increased from ${formattedCompared}s to ${formattedCurrent}s.`,
            decreased: `Your website's loading time has decreased from ${formattedCompared}s to ${formattedCurrent}s.`,
            equal: `Your website was loaded in ${formattedCurrent}s`,
        },
    };

    return (
        <Tooltip className="summary-tooltip" title={tooltipMessages[resourceType][getDataTrend(currentValue, comparedTo)]}>
            <Icon type="question-circle" />
        </Tooltip>
    );
}
